<template>
  <el-dialog custom-class="el-popup-parent-imgPop--dialog" class="imgPop"  :visible.sync="showtag" width="950px" :close-on-click-modal='false' v-dialogDrag append-to-body @close="close_dialog">
    <div class="header_part" slot="title">
      <span class="title">{{ editId ? $t('components_basic_addarticle_index_2003') : $t('components_basic_addarticle_index_2004') }}{{ articleWords }}</span>
    </div>
    <div class="pop_content" v-loading='isloading'>
      <div class="tabLine">
        <ul>
          <li v-for="(item, index) in pageList" :key="index" @click="changeSe(index)" :class="{ active: index == selectLine }" v-if="articleType == 11 && item.value == 1 ? false : true ">
            <p>{{ item.label }}</p>
          </li>
        </ul>
      </div>
      <div class="showPart">
        <message
          ref="infoForm"
          v-show="selectLine === 0"
          :tagList="tagList"
          :total="total"
          :proParams="proParams"
          :articleInfor="article.articleInfor"
          :treeData="tree_data"
          :articleWords="articleWords"
          @getTypes="gettypeList"
          :articleType="articleType"
        ></message>
        <kind_editor :content.sync="article.content.value" v-if="selectLine === 1" @on-content-change="onContentChange" width='768' height='260'></kind_editor>
        <ai_command v-if="selectLine === 1" :type="'wt'" @pushCont="pushCont" :command_type ="(proParams.objectType == 'news' ? 'article' : proParams.objectType) + '_detail'"></ai_command>
        <seo
          ref="infoSeo"
          v-show="selectLine === 2 + tabs.length"
          :seoData="article.seo"
          :articleInfor="article.articleInfor"
          :articleWords="articleWords"
          :autoSeo="autoSeo"
          :handerSeo="handerSeo"
          seoType="article"
          :seoTitleType ="(proParams.objectType == 'news' ? 'article' : proParams.objectType)"
        ></seo>
      </div>
    </div>
    <div class="btn-footer">
      <el-button type="primary" @click="sendData" :loading="isloading" :disabled="confirmDisabled">{{$t('components_basic_addarticle_index_2005', [ articleWords ])}}</el-button>
      <el-button @click="close_dialog" :loading="isloading">{{$t('view_public_topbar_14')}}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import i18n from '../../language/index'

import {lockScroll, getStaticStr} from '@/base/base'
import { gettypeList, saveArtical, getArticalInfo,getTagsList } from '@/api/app.js';
import message from './message.vue';
import seo from '../basic_common/seo.vue';
import mp4img from "@/assets/yun_icon/MP4.png";
import ai_command from "../ai_command/index.vue";
export default {
  props: {
    articleType: {
      type: Number,
      default: 1 //1:新闻 2:帮助 3:案例 4:下载 5:图册 11:视频
    },
    editId: {
      type: Number,
      default: null
    },
    showTag: {
      type: Boolean,
      default: false
    }
  },
  data() {
    var myDate =Date.parse(new Date());
    return {
      //标签列表
      tagList:[],
      article: {
        articleInfor: {
          status: 1,
          title: '',
          //页面点击量
          click: 0,
          //手机站设置
          mobiletype: '',
          //分类名称
          category_name: '',
          //案例详情
          radio: '1',
          auto_issue: myDate,
          //分类
          sort: 0,
          author: '',
          album: [],
          imageUrl: [],
          summary: '',
          type_name: '',
          content: '', // 本地视频上传
          tag_id:'',
          tag_ids:'',
          static: '',
        },
        content: {
          value: ''
        },
        seo: {
          seo_title: '',
          // seo_keywords: [{value: ''},{value: ''},{value: ''}], //SEO关键词
          seo_keywords: [], //SEO关键词
          seo_description: ''
        }
      },
      addTree: [],
      tree_data: [],
      articleWords: i18n.t('widgets_basic_article_classification_edit_333'),
      tabs: [],
      pageList: [
        {
          label: i18n.t('components_basic_addarticle_index_2006'),
          value: 0
        },
        {
          label: i18n.t('components_basic_addarticle_index_2007'),
          value: 1
        },
        {
          label: i18n.t('components_basic_addarticle_index_2008'),
          value: 2
        }
      ],
      proParams: {
        title: i18n.t('components_basic_addarticle_index_2009'),
        type: 'add', // 类型： 新增（add）或编辑(edit)
        twebId: 0, // 网站ID
        pid: '0', // 分类类型pid
        id: '0', // 分类类型ID
        objectType: 'new', //  新增或编辑对象的类型 pro 分类类型
        typevalue: 1
      },
      autoSeo: {
        title: '',
        keywords: '',
        description: ''
      },
      handerSeo: {
        title: '',
        keywords: '',
        description: ''
      },
      showtag: true,
      typeValue: 1,
      dataVisible: this.showTag,
      selectLine: 0,
      imgUrl: [],
      content: '',
      total: 0,
      isloading:false,
      item: [
        'clearhtml',
        'selectall',
        'plainpaste',
        'undo',
        'redo',
        'heading',
        'fontname',
        'fontsize',
        'forecolor',
        'hilitecolor',
        'bold',
        'underline',
        'italic',
        'strikethrough',
        'subscript',
        'superscript',
        'align',
        'lineheight',
        'indent',
        'outdent',
        'insertorderedlist',
        'insertunorderedlist',
        'image',
        'flash',
        'link',
        'unlink',
        'media',
        'table',
        'hr',
        'pagebreak',
        'source',
        'fullscreen'
      ],
      confirmDisabled: true,
      isReset: true
    };
  },
  components: {
    message,
    seo,
    ai_command
  },
  watch: {
    dataVisible(val, oldVal) {
      this.$emit('update:showTag', val);
    },
    article: {
      handler () {
        if (!this.isReset) {
          this.confirmDisabled = false
        } else {
          this.confirmDisabled = true
          this.isReset = false
        }
      },
      deep: true
    }
  },
  methods: {
    getTagList() {
      getTagsList().then(res => {
        if (res.code == 200) {
          this.tagList = res.data;
        }
      }).catch(err => {
        this.$message.error(err)
      })
    },
    changeWords() {
      let type = this.articleType;
      //1:新闻 2:帮助 3:案例 4:下载 5:图册 11:视频
      switch (type) {
        case 1:
          this.articleWords = i18n.t('widgets_basic_article_classification_edit_333');
          this.proParams.objectType = 'news';
          break;
        case 2:
          this.articleWords = i18n.t('widgets_basic_article_classification_edit_335');
          this.proParams.objectType = 'help';
          break;
        case 3:
          this.articleWords = i18n.t('widgets_basic_article_classification_edit_334');
          this.proParams.objectType = 'case';
          break;
        case 4:
          this.articleWords = i18n.t('router_index_69');
          this.proParams.objectType = 'download';
          break;
        case 5:
          this.articleWords = i18n.t('components_basic_addarticle_index_2010');
          this.proParams.objectType = 'atlas';
          break;
        case 11:
          this.articleWords = i18n.t('view_download_index_181');
          this.proParams.objectType = 'video';
          break;
      }
      this.pageList[1].label = this.articleWords + i18n.t('components_basic_addarticle_index_2011');
      this.proParams.title = i18n.t('components_basic_addarticle_index_2004') + this.articleWords + i18n.t('widgets_basic_article_info_edit_348');
      this.proParams.typevalue = this.articleType;
    },
    gettypeList() {
      // 获取文章类型ID
      this.loading = true;
      let type = {
        type: this.articleType,
        hide:'false'
      };
      gettypeList(type)
        .then(res => {
          if (res.code === 200 && res.data && res.data.list instanceof Array) {
            this.tree_data = res.data.list.map(item => {
              return item;
            });
            let addtree = [];
            addtree = res.data.list.map(item => {
              return item;
            });
            this.addTree = addtree;
            this.total = res.data.total;
            // console.log(this.total);
          } else {
            this.tree_data = [];
          }
        })
        .catch(err => {
          this.$message.error(err.message);
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onContentChange(content) {
      this.article.content.value = content;
    },
    pushCont(data) {
      this.article.content.value = data.content;
      this.article.articleInfor.summary = data.summary;
    },
    ontabContentChange(index, val) {
      this.tabs[index].content = val;
    },
    changeSe(index) {
      this.selectLine = index;
    },
    closepage() {
      this.$nextTick(()=> {
          lockScroll(false)
      })
      if(this.isloading){
        return false
      }
      this.dataVisible = false;
      this.showtag = true;
      this.$store.commit('image_upload/set_showTag', false);
      this.$emit('closed');
    },
    sendData() {
      let tag = true;
      this.$refs.infoForm.$refs.article_infor.validate(valid => {
        tag = valid;
      });
      if (!tag) {
        this.selectLine = 0;
        this.$nextTick(() => {
            let isError = document.getElementsByClassName("is-error");
            if (isError.length > 0) {
              isError[0].scrollIntoView({
                // 滚动到指定节点
                // 值有start,center,end，nearest，当前显示在视图区域中间
                block: "center",
                // 值有auto、instant,smooth，缓动动画（当前是慢速的）
                behavior: "smooth"
              });
              return false;
            }
        }); 
        if($('.attrnormspart').find('.is-error').length > 0){
          this.$refs.infoForm.scrollIntoError()
        }
        return false;
      }
      if (!this.article.content.value) {
        this.$message.error(this.articleWords + i18n.t('components_basic_addarticle_index_2012'));
        this.selectLine = 1;
        return false;
      }

      this.$refs.infoSeo.$refs.seo_data.validate(valid => {
        tag = valid;
      });
      if(!tag){
        this.selectLine = 2;
        return false;
      }

      let sendData = {};
      if (this.article.articleInfor.imageUrl.length > 0) {
        this.sendData.img = this.article.articleInfor.imageUrl[0].filePath;
      }
      if (this.article.seo.seo_keywords) {
        this.article.seo.seo_keywords.map(item=> {
          item.value = item.value.replace(/[\uff0c]/g, ",")
        })
      }
      if (!this.article.seo.seo_title) {
        // this.article.seo.seo_title = this.article.articleInfor.name;
      }
      if (!this.article.seo.seo_keywords) {
        // this.article.seo.seo_keywords = this.article.articleInfor.name;
      }
      if (!this.article.seo.seo_description) {
        // this.article.seo.seo_description = this.article.articleInfor.summary;
      }
      sendData = this.article.articleInfor;
      let album_ids = [];
      for (let i = 0; i < this.article.articleInfor.imageUrl.length; i++) {
        album_ids.push(this.article.articleInfor.imageUrl[i].filePath);
      }
      if (this.editId) {
        sendData.id = this.editId;
      }
      if (this.article.articleInfor.imageUrl.length > 0) {
        sendData.img = this.article.articleInfor.imageUrl[0].filePath;
      }else{
        sendData.img =''
      }
      sendData.album_ids = album_ids.join(',');
      sendData.type = this.articleType;
      if(this.articleType !== 11){
        sendData.content = this.article.content.value;
        
      } else {
        // console.log(8888888888, this.article.articleInfor.video.uploadtype)
      
        // param.filename = this.imageUrl[0].fileName;
        if(this.article.articleInfor.video.uploadtype == 1 ) { //本地视频
          if(this.article.articleInfor.video.imageUrl.length > 0){
            sendData.filename = this.article.articleInfor.video.imageUrl[0].fileName
            sendData.content = this.article.articleInfor.video.imageUrl[0].filePath;
          } else  sendData.content = '';
          
        }  else {
            sendData.content = this.article.articleInfor.content;
        }
        
        if(!sendData.content){
          this.$message.error(i18n.t('components_basic_addarticle_index_2013'));
          return;
        }
        /* if(this.article.articleInfor.video.uploadtype == 21 &&this.article.articleInfor.video.imageUrl.length == 0){
          this.$message.error('视频不能为空');
          return;
        } */
        
      }
      
      sendData.seo_title = this.article.seo.seo_title;
      sendData.seo_keywords = this.article.seo.seo_keywords;
      sendData.keyWords = this.article.seo.seo_keywords;
      sendData.seo = {
        title: this.article.seo.seo_title,
        keywords: this.article.seo.seo_keywords,
        description: this.article.seo.seo_description
      }
      sendData.seo_description = this.article.seo.seo_description;
      if(sendData.auto_issue && sendData.auto_issue.length == 13) {
        sendData.auto_issue = sendData.auto_issue / 1000;
      }
      if (sendData.title && !sendData.static) {
        sendData.static = getStaticStr(sendData.title);
      }
      if (sendData.static) {
        sendData.static = getStaticStr(sendData.static);
      }
      // console.log(sendData);
      this.isloading = true
      saveArtical(sendData).then(res => {
        if (res.code === 200) {
          this.$message.success(i18n.t('components_basic_addarticle_index_2014'));
          if (this.editId) {
            this.$emit('closed');
            this.$emit('submit_sure', res.data);
            this.showtag = true;
            this.closepage();
          } else {
            this.$confirm(i18n.t('components_basic_addarticle_index_2015'), {
              confirmButtonText: i18n.t('view_public_topbar_15'),
              cancelButtonText: i18n.t('components_basic_addarticle_index_2016'),
              type: 'warning'
            }).then(() => {
              // 确定
              this.$emit('closed');
              this.$emit('submit_sure', res.data);
              this.showtag = true;
              this.closepage();
            }).catch(() => {
              // 继续添加
              this.$emit('submit_sure', res.data);
              this.clearData()
            })
          }
          
          // this.$emit('closed');
          // this.$emit('submit_sure', res.data);
          // this.showtag = true;
          // this.closepage();
        } else {
          if(sendData.auto_issue.length == 10) {
            sendData.auto_issue = sendData.auto_issue * 1000;
          }
          this.$message.error(res.message);
        }
        // this.loading = false;
        // this.isloading = false;
      }).finally(()=>{
        this.isloading = false
      });
    },
    getArticleDetail() {
      this.loading = true;
      getArticalInfo({
        id: this.editId
      })
        .then(res => {
          if (res.code == 200) {
            this.setInfo(res.data);
          }
        })
        .catch(err => {
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    setInfo(articleInfo) {
      // console.log(articleInfo);
      this.article.articleInfor.title = articleInfo.info.title;
      this.article.articleInfor.summary = articleInfo.info.summary;
      if(this.articleType ==1||this.articleType==2||this.articleType==3||this.articleType==11) {
        this.article.articleInfor.tag_ids = articleInfo.info.tag_ids
        this.article.articleInfor.tag_id = articleInfo.info.tag_ids
      }
      // 这个需要排除 视频的情况 视频的主图在下面的处理中给主图进行赋值了
      if(this.articleType !== 11) {
        for (let index in articleInfo.info.album) {
          let data = {
            filePath: articleInfo.info.album[index],
            id: index
          };
          this.article.articleInfor.imageUrl.push(data);
        }
      }
      this.article.content.value = articleInfo.info.content;
      this.article.articleInfor.type_name = articleInfo.info.category_name;
      this.article.articleInfor.author = articleInfo.info.author;
      this.article.articleInfor.category_id = articleInfo.info.category_id;
      this.article.articleInfor.auto_issue = articleInfo.info.auto_issue * 1000;
      this.article.articleInfor.sort = articleInfo.info.sort;
      this.article.articleInfor.click = articleInfo.info.click;
      this.article.articleInfor.static = articleInfo.info.static || '';
      this.article.seo.seo_title = articleInfo.info.seo.title;
      this.article.seo.seo_keywords = articleInfo.info.seo.keywords;
      this.article.seo.seo_description = articleInfo.info.seo.description;

      let seo_keywords = []
        if(articleInfo.info.seo.keywords !== null 
        && articleInfo.info.seo.keywords.length !== 0 
        && articleInfo.info.seo.keywords.split(',').length > 0) {
          articleInfo.info.seo.keywords.split(',').map((item,index)=> {
            seo_keywords.push({
              value: item
            })
          })
        } else {
          seo_keywords = []
        }
        this.article.seo.seo_keywords = seo_keywords;

      this.handerSeo.keywords = this.article.seo.seo_keywords;
      this.handerSeo.description = this.article.seo.seo_description;
      this.handerSeo.title = this.article.seo.seo_title;
      this.autoSeo.keywords = this.article.seo.seo_keywords;
      this.autoSeo.description = this.article.seo.seo_description;
      this.autoSeo.title = this.article.seo.seo_title;
      if(this.articleType == 11){
        this.video_data_init(articleInfo)
      }
    },
    //处理视频模式的兼容
    video_data_init(articleInfo) {

      if (!this.article.articleInfor.file) {
        this.article.articleInfor.file = {
          name: "",
          path: "",
        };
      }
      if(articleInfo.info.content){
        //this.article.articleInfor.content = articleInfo.info.content
        this.$set(this.article.articleInfor,'content',articleInfo.info.content)
      }
      if(articleInfo.info.file){
        //this.article.articleInfor.file = articleInfo.info.file
        this.$set(this.article.articleInfor,'file',articleInfo.info.file)
      }
      this.$set(this.article.articleInfor,'video',{
         uploadtype:1,
        imageUrl:[]
      })
      // this.article.articleInfor.video = {
      //   uploadtype:1,
      //   imageUrl:[]
      // }
      if(articleInfo.info.img){

      
        this.article.articleInfor.imageUrl.push({
          filePath: articleInfo.info.img,
          id: 0
        });
      }
      if (
        this.article.articleInfor.content &&
        this.article.articleInfor.file &&
        this.article.articleInfor.file.name != null
      ) {
        this.article.articleInfor.video.imageUrl.push({
            path:this.article.articleInfor.content ? this.article.articleInfor.content :mp4img,
            filePath: this.article.articleInfor.content,
            fileName: this.article.articleInfor.file.name,
        })
        this.article.articleInfor.content = '' // 本地上传 和 视频链接不能是同一个参数
      }
      else{
        this.article.articleInfor.video.uploadtype = 2;
      }
    },
    close_dialog () {
      this.showtag = true
      if (!this.confirmDisabled) {
        this.$confirm(i18n.t('view_dialog_index_170'), {
          confirmButtonText: i18n.t('view_public_topbar_24'),
          cancelButtonText: i18n.t('view_public_topbar_11'),
          type: 'warning'
        }).then(() => {
          // 不保存退出
          this.showtag = false
          this.$emit('closed');
          this.$nextTick(()=> {
            lockScroll(false)
          })
        }).catch(() => {
          // 啥也不做
        })
      } else {
        // 保存
        this.showtag = false
        this.$emit('closed')
        this.$nextTick(()=> {
          lockScroll(false)
        })
      }
    },
    clearData () {
      this.isReset = true
      this.selectLine = 0
      var myDate = Date.parse(new Date())
      this.article = {
        articleInfor: {
          status: 1,
          title: '',
          //页面点击量
          click: 0,
          //手机站设置
          mobiletype: '',
          //分类名称
          category_name: '',
          //案例详情
          radio: '1',
          auto_issue: myDate,
          //分类
          sort: 0,
          author: '',
          album: [],
          imageUrl: [],
          summary: '',
          type_name: ''
        },
        content: {
          value: ''
        },
        seo: {
          seo_title: '',
          seo_keywords: '',
          seo_description: ''
        }
      }
      this.$refs.infoForm.resetFields()
    }
  },
  mounted() {
    lockScroll(true)
    if (this.editId) {
      this.getArticleDetail();
    }
    this.gettypeList();
    this.changeWords();
    this.getTagList()
  }
};
</script>

<style scoped lang="scss">
@import '~@/css/global-variable.scss';
.imgPop {
  height: 100%;
  /deep/ .el-dialog {
    max-height: 690px;
    height: 690px;
    background: #fff;
    .el-dialog__header {
      padding: 0;
    }
    .el-dialog__body {
      padding: 0;
      height: 100%;
      .btn-footer {
        width: 100%;
        text-align: center;
        display: block;
        padding-top: 20px;
        .el-button {
          margin: 8px 18px;
          padding: 0 28px;
          height: 34px;
        }
      }
    }
    .el-dialog__footer {
      padding: 0;
    }
  }
  .header_part {
    height: 50px;
    padding-left: 20px;
    border-bottom: 1px solid #e3e2e8;
    .title {
      font-size: 16px;
      line-height: 1;
      color: #333;
      line-height: 50px;
    }
    .titleTip {
      font-size: 12px;
      line-height: 1;
      color: #666;
      margin-left: 5px;
      line-height: 50px;
    }
  }
  
  .pop_content {
    width: 100%;
    font-size: 0;
    border-bottom: 1px solid #e3e2e8;
    height: calc(100% - 150px);
    .tabLine {
      display: inline-block;
      vertical-align: top;
      font-size: 12px;
      width: 142px;
      height: 100%;
      text-align: center;
      border-right: 1px solid #e3e2e8;
      ul {
        margin-right: -1px;
        max-height: 100%;
        overflow: auto;
      }
      li {
        height: 65px;
        line-height: 65px;
        cursor: pointer;
        border: 1px solid transparent;
        border-left: 0;
        border-right-color: #e3e2e8;
        transition: border-bottom 0.2s ease, border-top 0.2s ease;
        margin-top: -1px;
        position: relative;
      }
      li.active {
        color: $theme-primary;
        border-right-color: #fff;
        border-top-color: #e3e2e8;
        border-bottom-color: #e3e2e8;
        font-size: 14px;
      }
      li.active:before {
        content: '';
        width: 6px;
        background-color: $theme-primary;
        height: 65px;
        position: absolute;
        left: 0;
        top: 0;
      }
      li:first-child {
        border-top: 0;
      }
    }
    .showPart {
      display: inline-block;
      vertical-align: top;
      margin-top: 40px;
      height: calc(100% - 40px);
      padding: 0 20px 10px 20px;
      overflow-y: auto;
      .childPagePart {
        width: 745px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/basic_addArticle/index.vue